export function initData(): any {
  // this is really fast don't worry
  return JSON.parse(document.getElementById('reactroot').getAttribute('data'));
}
